import Login from "../Pages/Auth/Login";
import OAuthRedirect from "../Pages/Auth/OAuthRedirect";
import AuthorisationErrorPage from "../Pages/AuthorisationErrorPage";
import ErrorPage from "../Pages/ErrorPage";
import ShippingCalculator from "../Pages/ShippingCalculator/ShippingCalculator";
import {SuggestibleRouteInterface} from "./TopRoutes";

const PublicRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Login',
        path: '/login',
        element: <Login />,
        skipSuggestion: true
    },
    {
        title: 'OAuth Callback',
        path: '/oauth-callback',
        element: <OAuthRedirect />,
        skipSuggestion: true
    },
    {
        title: 'Shipping Calculator',
        path: '/shipping-calculator/:weight?/:width?/:height?/:depth?',
        element: <ShippingCalculator />
    },
    {
        title: 'Error',
        path: '/error',
        element: <ErrorPage />,
        skipSuggestion: true
    },
    {
        title: 'Unauthorised',
        path: '/unauthorised',
        element: <AuthorisationErrorPage />,
        skipSuggestion: true
    }
]

export {PublicRoutes}
